import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ivclass from '../../../../Modules/IVClass';
import HeaderItemIcon from '../../HeaderItemIcon';
const Title = (props) => {
    const { title, icon, color } = props;
    return (_jsxs(React.Fragment, { children: [icon && _jsx(HeaderItemIcon, { icon: icon }), _jsx("div", { className: ivclass('iv-inline-block', color || 'iv-text-grey-85', 'iv-m-heading-3xs', 'iv-text-heading-3xs', 'iv-font-semibold'), children: title })] }));
};
export default Title;
